import './antAlert.less';

import React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { Alert, AlertProps } from 'antd';
import b_ from 'b_';

export type AntAlertProps = AlertProps & {};

const b = b_.with('ant-alert-wrapper');

export const AntAlert = observer((props: AntAlertProps) => {
	const { className, ...antNativeProps } = props;

	const classes = classnames(b({ clickable: props.onClick != null }), className);

	return <Alert className={classes} {...antNativeProps} />;
});
